import React from "react";
import DatePicker from "../../../Components/DatePicker/DatePicker";

const BudgetHeader = (props) => {
  return (
    <header className="bg-slate-900 text-white shadow">
      <div className="flex items-center justify-center px-4 py-3 md:px-6">
        <DatePicker selectDateHandler={props.selectDateHandler} currentDate={props.currentDate} />
      </div>
    </header>
  );
};

export default BudgetHeader;
